module.exports = __webpack_public_path__ + "static/media/veneto-3-02.213aa17e.jpg";